import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles((theme) => ({
  root: {
    // height: 235,
    height: "calc(425px - 137px)",
    borderBottom: "solid 1px rgb(215 219 223 / 65%)",
    // "@media(min-width:1530px)": {
    //     height: 'calc(425px - 137px)',
    // }
  },
  conversationList: {
    padding: "0 12px",
    margin: 0,
    listStyle: "none",
    "& li": {
      borderBottom: "solid 1px rgb(215 219 223 / 65%)",
      padding: "10px 0 7px",
      "&:last-child": {
        border: "none",
      },
      "& .avatar-img": {
        margin: "0 auto",
      },
      "& p": {
        margin: "3px 10px 3px 0",
        wordBreak: "break-word",
      },
    },
    "& .MuiOutlinedInput-adornedStart": {
      borderBottom: "none !important",
    },
  },
  comment: {
    "& .msg-reaction": {
      right: 0,
      top: -4,
      opacity: 0,
      transition: "opacity 0.3s",
    },
    "&:hover": {
      "& .msg-reaction": {
        opacity: 1,
      },
    },
  },
  userName: {
    width: 50,
    minWidth: 50,
    textAlign: "center",
    marginRight: 10,
  },
  newTag: {
    border: "solid 1px #E8EFF6",
    borderRadius: 25,
    fontSize: 12,
    padding: "0 6px",
    height: 20,
    "& i": {
      background: "#EF7713",
      width: 8,
      height: 8,
      borderRadius: "50%",
      display: "inline-block",
      marginRight: 2,
    },
  },
}));
